/**
 * Mapa centralizado de todas as rotas da aplicação.
 */
export const PATH_MAP = {
  /**
   * Página raiz do sistema.
   */
  ROOT_PAGE: "/",

  /**
   * Página de termos de serviços.
   */
  TERMS_OF_SERVICE: "/terms-of-service",

  /**
   * Página de política de privacidade.
   */
  PRIVACY_POLICY: "/privacy-policy",

  /**
   * Página de política de cancelamento e arrependimento.
   */
  CANCELLATION_POLICY: "/cancellation-policy",

  /**
   * Página de política de ressarcimento.
   */
  REFUND_POLICY: "/refund-policy",

  /**
   * Página da cozinha.
   */
  KITCHEN_PAGE: "/kitchen",

  /**
   * Página do bar.
   */
  BAR_PAGE: "/bar",

  /**
   * Página de recuperar senha
   */
  RECOVER_PASSWORD: "/reset-password",

  /**
   * Página de login.
   */
  ROOT_LOGIN: "/login",

  /**
   * Página de login administrativo global.
   */
  ADMIN_LOGIN_PAGE: "/admin/login",

  /**
   * Página do dashboard administrativo global.
   */
  ADMIN_DASHBOARD_PAGE: "/admin/dashboard",

  /**
   * Landing page comercial para cadastro de revendedores.
   */
  RESELLER_LANDING_PAGE: "/seja-um-revendedor",

  /**
   * Página de cadastro autoatendido de revendedor.
   */
  RESELLER_SIGNUP_PAGE: "/seja-um-revendedor/cadastro",

  /**
   * Página de login do revendedor.
   */
  RESELLER_LOGIN_PAGE: "/seja-um-revendedor/login",

  /**
   * Painel do revendedor.
   */
  RESELLER_DASHBOARD_PAGE: "/revendedor/painel",
  /**
   * Página pública explicando os fluxos do sistema.
   */
  HOW_IT_WORKS_PAGE: "/como-funciona",

  /**
   * Página pública com a biblioteca de tutoriais.
   */
  PUBLIC_TUTORIALS_PAGE: "/tutoriais",

  /**
   * Página para buscar restaurantes.
   */
  RESTAURANT_SEARCH_PAGE: "/restaurantes",

  /**
   * Página pública de grupo de lojas.
   */
  STORE_GROUP_PUBLIC_PAGE: "/g/:groupSlug",

  /**
   * Página comercial para cardápio digital público.
   */
  DIGITAL_MENU_LANDING_PAGE: "/cardapio-digital-publico",

  /**
   * Página comercial focada em implantação gratuita do cardápio digital.
   */
  FREE_MENU_SETUP_LANDING_PAGE: "/cardapio-pronto-gratis",

  /**
   * Página pública de diagnóstico e captação de leads.
   */
  LEAD_QUIZ_PAGE: "/quiz",

  /**
   * Página pública de quiz comercial configurável.
   */
  LEAD_QUIZ_SLUG_PAGE: "/quiz/:quizSlug",

  /**
   * Monta o link público de um quiz comercial.
   */
  LEAD_QUIZ_LINK: (quizSlug: string) => `/quiz/${quizSlug}`,

  /**
   * Página dinâmica de solução por público.
   */
  AUDIENCE_LANDING_PAGE: "/solucoes/:audienceSlug",

  /**
   * Página de cadastro.
   */
  ROOT_SIGN_UP_FIRST_STEP: "/sign-up-first-step",

  /**
   * Página 2 de cadastro .
   */
  ROOT_SIGN_UP_SECOND_STEP: "/sign-up-second-step",

  /**
   * Página final de cadastro .
   */
  ROOT_SIGN_UP: "/sign-up",

  /**
   * Qualquer página.
   */
  ROOT_ALL: "*",

  /**
   *  Página principal do painel (home).
   */
  HOME_PAGE: "/home",

  /**
   * Página de mesas.
   */
  TABLE_PAGE: "/home/tables",

  /**
   * Página de comandas.
   */
  COMMANDS_PAGE: "/home/commands",

  /**
   * Página de clientes.
   */
  CUSTOMER_PAGE: "/home/customer",

  /**
   * Página de verificação de saída do cliente.
   */
  CUSTOMER_EXIT_CHECK_PAGE: "/home/customer-exit-check",

  /**
   * Página de pedidos reservados.
   */
  RESERVED_ORDERS_PAGE: "/home/reserved-orders",

  /**
   * Página de lançamentos avulsos externos.
   */
  MANUAL_EXTERNAL_ORDERS_PAGE: "/home/manual-external-orders",

  /**
   *  Página de receita diária.
   */
  DAILY_INCOME_PAGE: "/home/daily-income",

  /**
   * Página de receita mensal.
   */
  MONTH_INCOME_PAGE: "/home/month-income",

  /**
   * Página de métricas do cardápio.
   */
  MENU_METRICS_PAGE: "/home/menu-metrics",

  /**
   * Página de métricas financeiras e operacionais do rodízio.
   */
  RODIZIO_METRICS_PAGE: "/home/rodizio-metrics",

  /**
   * Página de métricas por funcionário.
   */
  EMPLOYEE_METRICS_PAGE: "/home/employee-metrics",

  /**
   * Página de resumo de salários, pró-labore e comissões.
   */
  PAYROLL_SUMMARY_PAGE: "/home/payroll-summary",

  /**
   * Página de refeições.
   */
  MEALS_PAGE: "/home/meals",

  /**
   *  Página de bebidas.
   */
  DRINKS_PAGE: "/home/drinks",

  /**
   *  Página de categoria.
   */
  CATEGORY_PAGE: "/home/category",

  /**
   * Página de combos.
   */
  COMBO_PAGE: "/home/combos",

  /**
   *  Página de adicionais.
   */
  ADDTIONAL_PAGE: "/home/addtional",

  /**
   * Página de seleções configuráveis.
   */
  SELECTION_PAGE: "/home/selection",

  /**
   * Página de promoções.
   */
  PROMOTIONS_PAGE: "/home/promotions",

  /**
   * Página de cupons.
   */
  COUPONS_PAGE: "/home/coupons",

  /**
   *  Página de prêmios.
   */
  AWARDS_PAGE: "/home/awards",

  /**
   * Página de serviços extras.
   */
  SERVICES_PAGE: "/home/services",

  /**
   * Página de avisos do cardápio público.
   */
  NOTICES_PAGE: "/home/notices",

  /**
   * Página de administração das reservas por ambiente.
   */
  RESTAURANT_RESERVATIONS_PAGE: "/home/reservations",

  /**
   * Página de ambientes disponíveis para reservas.
   */
  RESTAURANT_RESERVATION_AREAS_PAGE: "/home/reservation-areas",

  /**
   * Página do registro de ponto do próprio funcionário.
   */
  MY_TIME_CLOCK_PAGE: "/home/my-time-clock",

  /**
   * Página de administração do controle de ponto.
   */
  TIME_CLOCK_PAGE: "/home/time-clock",

  /**
   * Página de checklists do próprio funcionário.
   */
  MY_CHECKLISTS_PAGE: "/home/my-checklists",

  /**
   * Página de administração de checklists.
   */
  CHECKLISTS_PAGE: "/home/checklists",

  /**
   * Página de configuração e planos do rodízio sob demanda.
   */
  RODIZIO_PAGE: "/home/rodizio",

  /**
   * Página da empresa.
   */
  COMPANY_PAGE: "/home/company",

  /**
   * Página de grupos de lojas públicas.
   */
  STORE_GROUPS_PAGE: "/home/store-groups",

  /**
   * Página de configuração da impressão automática por agente local.
   */
  PRINT_AUTOMATION_PAGE: "/home/print-automation",

  /**
   * Página de configuração da automação local do WhatsApp.
   */
  WHATSAPP_AUTOMATION_PAGE: "/home/whatsapp-automation",

  /**
   * Página de configuração do CRM e autoatendimento do WhatsApp.
   */
  WHATSAPP_CRM_PAGE: "/home/whatsapp-crm",

  /**
   * Página de configuração da integração oficial do WhatsApp pela Meta.
   */
  WHATSAPP_OFFICIAL_PAGE: "/home/whatsapp-official",

  /**
   * Página de configuração da integração Resposta Aí para WhatsApp.
   */
  RESPOSTA_AI_INTEGRATION_PAGE: "/home/whatsapp-resposta-ai",

  /**
   * Página de integração e métricas por IA.
   */
  AI_INTEGRATION_PAGE: "/home/ai-integration",

  /**
   * Página de emissão de NFC-e.
   */
  FISCAL_INTEGRATION_PAGE: "/home/fiscal-integration",

  /**
   * Página de importação e organização de notas fiscais de compra.
   */
  FISCAL_IMPORTS_PAGE: "/home/fiscal-imports",

  /**
   * Página de planos e assinatura.
   */
  PLANS_PAGE: "/home/plans",

  /**
   * Página de funcionários.
   */
  EMPLOYEES_PAGE: "/home/employees",

  /**
   * Página do painel do motoboy.
   */
  COURIER_PANEL_PAGE: "/courier",

  /**
   * Página de parceiros de entrega.
   */
  COURIER_PARTNERS_PAGE: "/home/courier-partners",

  /**
   * Página de central de ajuda.
   */
  HELP_CENTER_PAGE: "/home/help-center",

  /**
   * Página de tutoriais.
   */
  TUTORIALS_PAGE: "/home/tutorials",

  /**
   * Página de diagnóstico e reinscrição de notificações push.
   */
  PUSH_NOTIFICATIONS_PAGE: "/home/push-notifications",

  /**
   * Base das rotas públicas.
   */
  PUBLIC_BASE: "/:restaurantSlug/*",

  /**
   * Link público direto para as reservas do restaurante.
   */
  PUBLIC_RESERVATIONS: "/:restaurantSlug/reservas",

  /**
   * Monta o link público de reservas para um restaurante.
   */
  PUBLIC_RESERVATIONS_LINK: (restaurantSlug: string) => `/${restaurantSlug}/reservas`,

  /**
   * Auto-atendimento.
   */
  TABLE_SELF_SERVICE: "/:restaurantSlug/tablet",

  /**
   * Tela pública com o código rotativo do controle de ponto, para deixar exibida em uma tela do restaurante.
   */
  TIME_CLOCK_PUBLIC_CODE_PAGE: "/:restaurantSlug/ponto-codigo",

  /**
   * Monta o link público da tela do código rotativo do controle de ponto para um restaurante.
   */
  TIME_CLOCK_PUBLIC_CODE_LINK: (restaurantSlug: string) => `/${restaurantSlug}/ponto-codigo`,
} as const
